import { Injectable } from '@angular/core';
import { MYACCOUNT_APPID, WIRELESS_ROUTE } from '@rci/self-serve-fido/app.constant';
import {
  AnalyticsConfiguration,
  pageViewEvent,
  selfServeCompleteWithPageViewEvents,
  selfServeStartWithPageViewEvents,
} from '@rci/self-serve-fido/core/analytics';
import { ICompleteUniversalDataLayer } from '@rogers/analytics';

const pageName = 'change my voicemail password';
const baseHierarchy = [MYACCOUNT_APPID, WIRELESS_ROUTE, pageName];

const page = {
  name: pageName,
  hierarchy: baseHierarchy,
};

const pageErrorEvent = {
  page,
  events: pageViewEvent,
};

const selfServeVoicemail = {
  selfServe: {
    type: 'transaction',
    name: 'actv-myfido-update vm password',
  },
};

@Injectable()
export class ChangeVoicemailAnalyticsConfigurationService implements AnalyticsConfiguration {
  mappings: Record<string, ICompleteUniversalDataLayer> = {
    voicemailPageOnLoad: {
      page,
      events: selfServeStartWithPageViewEvents,
      ...selfServeVoicemail,
    },
    changeSuccess: {
      page,
      events: selfServeCompleteWithPageViewEvents,
      ...selfServeVoicemail,
    },
    formFieldError: pageErrorEvent,
    changeSubmitFailureError: pageErrorEvent,
  };

  callBackFunctions?: Record<string, (payload: ICompleteUniversalDataLayer) => void> = {
    changeVoicemail: () => {
      /* empty */
    },
  };
}
